module.exports = __webpack_public_path__ + "img/compilation.8af52a8b.png";